<!-- Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. -->

<div (click)="toggleMenu()" [closeWhenIgnored]="menuShown$" (whenIgnored)="closeMenu()">
	<div class="multi-edit_thumbnail">
		<div class="{{ 'multi-edit_thumbnail--' + currentType }}">
			<!-- This is the ticket shape -->
			<span
				class="multi-edit_thumbnail--count"
				automationId="multiEditCount"
				*ngIf="typeCounts[currentType] > 0"
				>{{ 'x' + typeCounts[currentType] }}</span
			>
		</div>
		<i class="arrow-drop-down-icon material-icons">arrow_drop_down</i>
	</div>

	<!-- DROPDOWN -->
	<div *ngIf="menuShown$ | async" class="menu-zindex menu-light menu-max-height absolute-align-left">
		<div *ngFor="let type of typeCounts | keyvalue">
			<div *ngIf="type.value > 0" class="menu-item--light" (click)="setCurrentType(type.key)">
				<span class="{{ 'multi-edit_icon--' + type.key }}"></span>
				{{ getPrettyTypeName(type.key) }} ({{ type.value }})
			</div>
		</div>
	</div>
</div>
